module.exports = __webpack_public_path__ + "img/reset-password-v2.ef334c4b.svg";